<div
    class="assessor-notes__container"
    *ngIf="!readOnlyUser"
    [class.assessor-notes__container--collapsed]="!isExpanded"
>
    <div class="assessor-notes__header">
        <h3 class="assessor-notes__title">
            <button
                class="assessor-notes__toggle"
                type="button"
                [attr.aria-expanded]="isExpanded"
                [attr.aria-controls]="'assessor-notes-content-' + componentId"
                (click)="toggleExpanded(); $event.stopPropagation()"
            >
                <span>{{ aggregateByLicense ? 'Assessment Notes' : 'Requirement Notes' }}</span>
            </button>
        </h3>
        <div class="assessor-notes__header-actions">
            <button *ngIf="allowAddingNotes" nz-button nzType="primary" nzSize="small" type="button"
                class="cb4-button assessor-notes__add" (click)="onAddNoteClicked(); $event.stopPropagation()"
                [disabled]="isLoading || isFormVisible || (!hasSelection && !aggregateByLicense) || readOnlyUser">
                <i nz-icon nzType="plus" aria-hidden="true"></i>
                <span>Add Note</span>
            </button>
            <button class="assessor-notes__collapse-toggle" type="button"
                [attr.aria-label]="isExpanded ? 'Collapse Assessment Notes' : 'Expand Assessment Notes'"
                [attr.aria-expanded]="isExpanded"
                [attr.aria-controls]="'assessor-notes-content-' + componentId"
                (click)="toggleExpanded(); $event.stopPropagation()">
                <span nz-icon [nzType]="isExpanded ? 'up' : 'down'" aria-hidden="true"></span>
            </button>
        </div>
    </div>
    <div
        class="assessor-notes__content"
        [class.assessor-notes__content--expanded]="isExpanded"
        [attr.aria-hidden]="!isExpanded"
    >
        <div
            class="assessor-notes__content-inner"
            [id]="'assessor-notes-content-' + componentId"
            [attr.inert]="isExpanded ? null : ''"
        >
            <p class="assessor-notes__not-included">Only administrators and assessors assigned to this assessment can see these notes (users with read-only access cannot).<br />These notes will not be included in the completed report.</p>

            <form
                *ngIf="isFormVisible"
                class="assessor-notes__form"
                [formGroup]="noteForm"
                novalidate
                (ngSubmit)="onSubmitNote()"
            >
                <div class="assessor-notes__form-row">
                    <label
                        class="assessor-notes__form-label"
                        [attr.for]="'assessor-note-body-' + componentId"
                    >
                        Note
                    </label>
                    <div class="assessor-notes__input-wrapper">
                        <textarea
                            nz-input
                            formControlName="body"
                            class="assessor-notes__textarea"
                            rows="4"
                            [id]="'assessor-note-body-' + componentId"
                        ></textarea>
                        <span
                            class="assessor-notes__error"
                            *ngIf="
                                noteForm.controls.body.touched &&
                                (noteForm.controls.body.errors?.required || noteForm.controls.body.errors?.whitespace)
                            "
                        >
                            A note is required.
                        </span>
                        <span
                            class="assessor-notes__error"
                            *ngIf="noteForm.controls.body.errors?.maxlength || noteForm.controls.body.errors?.byteLength"
                        >
                            Notes must be 65,535 characters or fewer.
                        </span>
                    </div>

                    <div class="assessor-notes__form-actions">
                        <button
                            nz-button
                            class="cb4-button"
                            nzType="primary"
                            nzSize="small"
                            type="submit"
                            [disabled]="isSubmitting"
                            [nzLoading]="isSubmitting"
                        >
                            Submit
                        </button>
                        <button
                            nz-button
                            class="cb4-button"
                            nzType="default"
                            nzSize="small"
                            type="button"
                            (click)="onCancelForm()"
                            [disabled]="isSubmitting"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </form>

            <div class="assessor-notes__filters">
                <button
                    *ngIf="!areFiltersVisible; else assessorNoteFilters"
                    nz-button
                    nzType="link"
                    nzSize="small"
                    type="button"
                    class="assessor-notes__filter-reveal"
                    (click)="showFilters()"
                >
                    <span nz-icon nzType="filter" aria-hidden="true"></span>
                    Search / Filter
                </button>
                <ng-template #assessorNoteFilters>
                    <div class="assessor-notes__filter-controls">
                        <div class="assessor-notes__filter-field">
                            <input
                                nz-input
                                type="search"
                                maxlength="256"
                                [id]="'assessor-note-search-' + componentId"
                                [disabled]="isSubmitting || editingNoteId !== null"
                                [ngModel]="noteSearchText"
                                (ngModelChange)="onNoteSearchChange($event)"
                                placeholder="Search note contents"
                            />
                        </div>
                        <div class="assessor-notes__filter-field">
                            <nz-select
                                [id]="'assessor-note-authors-' + componentId"
                                nzMode="multiple"
                                nzPlaceHolder="Filter by user"
                                aria-label="Filter assessment notes by user"
                                [nzAllowClear]="true"
                                [nzDisabled]="isSubmitting || editingNoteId !== null"
                                [ngModel]="selectedAuthorNames"
                                (ngModelChange)="onAuthorFilterChange($event)"
                            >
                                <nz-option *ngFor="let author of authorOptions" [nzValue]="author" [nzLabel]="author"></nz-option>
                            </nz-select>
                        </div>
                    </div>
                </ng-template>
            </div>

            <nz-spin [nzSpinning]="isLoading" nzSize="small" class="assessor-notes__spinner">
                <div *ngIf="isExpanded && filteredNotes.length > 0; else assessorNotesEmpty" class="assessor-notes__table">
                    <div
                        *ngFor="let note of filteredNotes; trackBy: trackById"
                        class="assessor-notes__row"
                        [class.assessor-notes__row--editing]="editingNoteId === note.id"
                        [@rowAnimation]
                    >
                        <div class="assessor-notes__note">
                            <p
                                *ngIf="editingNoteId !== note.id"
                                class="assessor-notes__note-text"
                                [class.assessor-notes__note-text--qa]="isQaRole(note.userRole)"
                            >
                                {{ note.body }}
                            </p>
                            <div *ngIf="editingNoteId === note.id" [formGroup]="editNoteForm">
                                <textarea
                                    nz-input
                                    formControlName="body"
                                    class="assessor-notes__textarea"
                                    rows="4"
                                    [id]="'edit-assessor-note-' + componentId + '-' + note.id"
                                    [attr.maxlength]="65535"
                                    [readOnly]="isSavingEdit"
                                ></textarea>
                                <span
                                    class="assessor-notes__error"
                                    *ngIf="editNoteForm.controls.body.touched && (editNoteForm.controls.body.errors?.required || editNoteForm.controls.body.errors?.whitespace)"
                                >
                                    A note is required.
                                </span>
                                <span
                                    class="assessor-notes__error"
                                    *ngIf="editNoteForm.controls.body.errors?.maxlength || editNoteForm.controls.body.errors?.byteLength"
                                >
                                    Notes must be 65,535 characters or fewer.
                                </span>
                            </div>
                        </div>
                        <div class="assessor-notes__timestamp" *ngIf="editingNoteId !== note.id">
                            <span class="assessor-notes__timestamp-date">
                                {{ formatDateTimeDisplay(note.createdAt) }}
                            </span>
                            <span *ngIf="wasNoteEdited(note)" class="assessor-notes__timestamp-updated">
                                Last updated {{ formatDateTimeDisplay(note.updatedAt) }}
                            </span>
                            <span
                                *ngIf="note.createdByDisplayName"
                                class="assessor-notes__timestamp-author"
                            >
                                Added by {{ note.createdByDisplayName }}
                            </span>
                            <span
                                *ngIf="note.userRole"
                                class="assessor-notes__timestamp-role"
                                [class.assessor-notes__timestamp-role--qa]="isQaRole(note.userRole)"
                            >
                                Assigned as: {{ note.userRole }}
                            </span>
                            <button
                                *ngIf="aggregateByLicense && getRequirementReferenceLabel(note.questionReference) as requirementLabel"
                                nz-button
                                nzType="primary"
                                nzSize="small"
                                class="cb4-button appendix-b__requirement-number assessor-notes__requirement-link"
                                type="button"
                                [attr.aria-label]="'Go to ' + requirementLabel"
                                (click)="onRequirementReferenceClick(note.questionReference)"
                            >
                                {{ requirementLabel }}
                            </button>
                        </div>
                        <div class="assessor-notes__row-actions">
                            <ng-container *ngIf="editingNoteId === note.id; else noteDefaultActions">
                                <button nz-button nzType="text" type="button" class="cb4-button assessor-notes__delete"
                                    (click)="onSaveEdit(note)" [disabled]="isSavingEdit"
                                    [attr.aria-label]="'Save changes to assessment note ' + note.id">
                                    <i nz-icon [nzType]="isSavingEdit ? 'loading' : 'check'" class="assessor-notes__delete-icon"></i>
                                </button>
                                <button nz-button nzType="text" type="button" class="cb4-button assessor-notes__delete"
                                    (click)="onCancelEdit()" [disabled]="isSavingEdit"
                                    [attr.aria-label]="'Cancel changes to assessment note ' + note.id">
                                    <i nz-icon nzType="close" class="assessor-notes__delete-icon"></i>
                                </button>
                            </ng-container>
                            <ng-template #noteDefaultActions>
                                <button *ngIf="canEditNote(note)" nz-button nzType="text" type="button"
                                    class="cb4-button assessor-notes__delete" (click)="onEditNote(note)"
                                    [disabled]="deletingNoteIds.has(note.id) || isLoading || editingNoteId !== null"
                                    [attr.aria-label]="'Edit assessment note ' + note.id">
                                    <i nz-icon nzType="edit" class="assessor-notes__delete-icon"></i>
                                </button>
                                <button *ngIf="canDeleteNote(note)" nz-button nzType="text" type="button" class="cb4-button assessor-notes__delete"
                                    (click)="onDeleteNote(note)" [disabled]="deletingNoteIds.has(note.id) || readOnlyUser"
                                    [attr.aria-label]="'Delete note created on ' + formatDateTimeDisplay(note.createdAt)">
                                    <i nz-icon [nzType]="deletingNoteIds.has(note.id) ? 'loading' : 'close'"
                                        class="assessor-notes__delete-icon"></i>
                                </button>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </nz-spin>

        <nz-pagination *ngIf="isExpanded && total > pageSize" [nzPageIndex]="pageIndex"
            [nzPageSize]="pageSize" [nzTotal]="total" [nzShowSizeChanger]="false"
            [nzDisabled]="isLoading || isSubmitting || isFormVisible || editingNoteId !== null || deletingNoteIds.size > 0"
            (nzPageIndexChange)="onPageChange($event)"></nz-pagination>

            <ng-template #assessorNotesEmpty>
                <div *ngIf="isExpanded && !isLoading" class="assessor-notes__empty">
                    {{ noteSearchText.trim() || selectedAuthorNames.length ? 'No assessment notes match these filters.' :
                        (aggregateByLicense ? 'No assessment notes have been added for this assessment yet.' :
                            'No assessment notes have been added for this requirement yet.') }}
                </div>
            </ng-template>
        </div>
    </div>
</div>
